module.exports = __webpack_public_path__ + "img/swiper_01.82920d44.jpg";